import { z } from 'zod';
import { positionSchema } from './positionSchema';

export const markerTypeSchema = z.union([
  z.literal('pin'),
  z.literal('surface'),
  z.literal('line'),
  z.literal('polygon'),
  z.literal('text'),
  z.literal('image'),
]);

const markerBaseSchema = z.object({
  type: markerTypeSchema,
  id: z.string(),
  opacity: z.number(),
  modelId: z.number().optional(),
});

const markerWithPositionBaseSchema = markerBaseSchema.extend({
  x: z.number(),
  y: z.number(),
});

export const markerPinSchema = markerWithPositionBaseSchema.extend({
  type: z.literal('pin'),
  width: z.number().optional(),
  height: z.number().optional(),
  number: z.number().optional(),
  color: z.string(),
});

export const markerSurfaceSchema = markerWithPositionBaseSchema.extend({
  type: z.literal('surface'),
  width: z.number(),
  height: z.number(),
  color: z.string(),
});

export const markerLineSchema = markerBaseSchema.extend({
  type: z.literal('line'),
  start: positionSchema,
  end: positionSchema,
  color: z.string(),
});

export const markerPolygonSchema = markerBaseSchema.extend({
  type: z.literal('polygon'),
  fillColor: z.string(),
  borderColor: z.string(),
  borderWidth: z.number(),
  points: z.array(positionSchema),
});

const fontNameSchema = z.union([
  z.literal('ARIAL'),
  z.literal('HELVETICA'),
  z.literal('TIMES_NEW_ROMAN'),
  z.literal('COURIER_NEW'),
  z.literal('GEORGIA'),
  z.literal('VERDANA'),
]);

export const markerTextSchema = markerWithPositionBaseSchema.extend({
  type: z.literal('text'),
  color: z.string(),
  text: z.string(),
  fontName: fontNameSchema.optional(),
  fontSize: z.number().optional(),
});

export const markerImageSchema = markerWithPositionBaseSchema.extend({
  type: z.literal('image'),
  width: z.number(),
  height: z.number(),
  url: z.string(),
});

export const markerWithPositionSchema = z.union([markerPinSchema, markerSurfaceSchema]);

export const markerSchema = z.union([
  markerPinSchema,
  markerSurfaceSchema,
  markerLineSchema,
  markerPolygonSchema,
  markerTextSchema,
  markerImageSchema,
]);
